import {Account} from '.';

export class AccountSearchResult {
  account?: Account;
  countryCode?: string;
  isAccountInPhoneBook?: boolean;
  phoneNumber?: string;
  email?: string;

  constructor(json: any) {
    this.account = json.account && new Account(json.account);
    this.countryCode = json.countryCode;
    this.isAccountInPhoneBook = json.isAccountInPhoneBook;
    this.phoneNumber = json.phoneNumber;
    this.email = json.email;
  }
}
